import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export default function Seo({
  pageKey,
  pathByLang,
  site = "https://www.atmnetss.com",
  image,
}) {
  const { i18n, t } = useTranslation();

  const lang = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const currentLang = lang === "es" ? "es" : "en";

  const title = t(`seo.${pageKey}.title`);
  const description = t(`seo.${pageKey}.description`);
  const keywords = t(`seo.${pageKey}.keywords`);

  const urlEs = `${site}${pathByLang.es}`;
  const urlEn = `${site}${pathByLang.en}`;
  const canonical = currentLang === "es" ? urlEs : urlEn;

  return (
    <Helmet>
      <html lang={currentLang} />

      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <link rel="canonical" href={canonical} />

      <link rel="alternate" hrefLang="es" href={urlEs} />
      <link rel="alternate" hrefLang="en" href={urlEn} />
      <link rel="alternate" hrefLang="x-default" href={urlEn} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta
        property="og:locale"
        content={currentLang === "es" ? "es_ES" : "en_US"}
      />
      <meta
        property="og:locale:alternate"
        content={currentLang === "es" ? "en_US" : "es_ES"}
      />

      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
